/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Fahrzeug hinzufügen`
};

const en_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Add your vehicle`
};

const es_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Añadir tu vehículo`
};

const fr_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouter votre véhicule`
};

const it_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi il tuo veicolo`
};

const nl_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Uw voertuig toevoegen`
};

const pt_itinerary__options__car_badge__register = /** @type {(inputs: {}) => string} */ () => {
	return `Adicionar o seu veículo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__car_badge__register(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__car_badge__register", locale)
	if (locale === "de") return de_itinerary__options__car_badge__register(inputs)
	if (locale === "en") return en_itinerary__options__car_badge__register(inputs)
	if (locale === "es") return es_itinerary__options__car_badge__register(inputs)
	if (locale === "fr") return fr_itinerary__options__car_badge__register(inputs)
	if (locale === "it") return it_itinerary__options__car_badge__register(inputs)
	if (locale === "nl") return nl_itinerary__options__car_badge__register(inputs)
	return pt_itinerary__options__car_badge__register(inputs)
};